var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-float",attrs:{"href":"https://wa.me/584123659519","target":"_blank","rel":"noopener noreferrer","title":"Contáctanos por WhatsApp"}},[_c('i',{staticClass:"bi bi-whatsapp"})])
}]

export { render, staticRenderFns }